/**
 * KAN-755: таблица скидок: название, тип, условия (summary с backend),
 * статус бейджем, на что действует. Кнопки изменить и удалить только при canEdit.
 */
import { Pencil, Trash2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { discountScopeText, discountStateView } from '@/lib/discountForm';
import type { DiscountListItem } from '@/types/discount';

interface DiscountsTableProps {
  items: DiscountListItem[];
  canEdit: boolean;
  onEdit: (item: DiscountListItem) => void;
  onDelete: (item: DiscountListItem) => void;
}

export function DiscountsTable({ items, canEdit, onEdit, onDelete }: DiscountsTableProps) {
  return (
    <div className="overflow-x-auto rounded-lg border bg-white">
      <Table aria-label="Скидки" data-testid="discounts-table">
        <TableHeader>
          <TableRow>
            <TableHead>Название</TableHead>
            <TableHead>Тип</TableHead>
            <TableHead>Условия</TableHead>
            <TableHead>Статус</TableHead>
            <TableHead>На что действует</TableHead>
            {canEdit && <TableHead className="w-24" />}
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((item) => {
            const state = discountStateView(item);
            return (
              <TableRow key={item.id} data-testid={`discount-row-${item.id}`}>
                <TableCell className="min-w-[160px] font-medium">{item.name}</TableCell>
                <TableCell className="whitespace-nowrap text-sm text-gray-700">{item.formula_label || item.formula}</TableCell>
                <TableCell className="min-w-[180px] text-sm text-gray-700">{item.summary || '-'}</TableCell>
                <TableCell>
                  <Badge variant={state.variant} data-testid={`discount-state-${item.id}`}>
                    {state.label}
                  </Badge>
                </TableCell>
                <TableCell className="text-sm text-gray-700">{discountScopeText(item)}</TableCell>
                {canEdit && (
                  <TableCell className="whitespace-nowrap text-right">
                    <Button
                      type="button"
                      variant="ghost"
                      size="sm"
                      aria-label={`Изменить: ${item.name}`}
                      onClick={() => onEdit(item)}
                    >
                      <Pencil className="h-4 w-4" />
                    </Button>
                    <Button
                      type="button"
                      variant="ghost"
                      size="sm"
                      aria-label={`Удалить: ${item.name}`}
                      onClick={() => onDelete(item)}
                    >
                      <Trash2 className="h-4 w-4 text-red-500" />
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
